const countryIdentificationCatalog = [
    {
        id: 157,
        geonamesId: 3996063,
        code: "MX",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
        },
        name: "México",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 2,
                code: "CURP",
                name: "CURP",
                isActive: true,
            },
            {
                id: 3,
                code: "INE",
                name: "INE",
                isActive: true,
            },
            {
                id: 4,
                code: "RFC",
                name: "RFC",
                isActive: true,
            },
        ],
    },
    {
        id: 233,
        geonamesId: 6252001,
        code: "US",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
        },
        name: "United States",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 2,
                code: "SSN",
                name: "SSN (Social Security Number)",
                isActive: true,
            },
            {
                id: 3,
                code: "DL",
                name: "Driver License",
                isActive: true,
            },
        ],
    },
    {
        id: 46,
        geonamesId: 3895114,
        code: "CL",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
        },
        name: "Chile",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CEDCAR",
                name: "ID/Personal ID",
                isActive: true,
            },
        ],
    },
    {
        id: 10,
        geonamesId: 3865483,
        code: "AR",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
        },
        name: "Argentina",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "DNI",
                name: "ID (National Identity Document)",
                isActive: true,
            },
        ],
    },
    {
        id: 68,
        geonamesId: 2510769,
        code: "ES",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "España",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "DNI",
                name: "ID (National Identity Document)",
                isActive: true,
            },
        ],
    },
    {
        id: 174,
        geonamesId: 3932488,
        code: "PE",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Perú",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "DNI",
                name: "ID (National Identity Document)",
                isActive: true,
            },
        ],
    },
    {
        id: 29,
        geonamesId: 3923057,
        code: "BO",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Bolivia",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CEDCAR",
                name: "ID/Personal ID",
                isActive: true,
            },
        ],
    },
    {
        id: 50,
        geonamesId: 3624060,
        code: "CR",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Costa Rica",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CEDCAR",
                name: "ID/Personal ID",
                isActive: true,
            },
        ],
    },
    {
        id: 63,
        geonamesId: 3658394,
        code: "EC",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Ecuador",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CEDCAR",
                name: "ID/Personal ID",
                isActive: true,
            },
        ],
    },
    {
        id: 165,
        geonamesId: 3617476,
        code: "NI",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Nicaragua",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CEDCAR",
                name: "ID/Personal ID",
                isActive: true,
            },
        ],
    },
    {
        id: 234,
        geonamesId: 3439705,
        code: "UY",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Uruguay",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CEDCAR",
                name: "ID/Personal ID",
                isActive: true,
            },
        ],
    },
    {
        id: 238,
        geonamesId: 3625428,
        code: "VE",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Venezuela",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CEDCAR",
                name: "ID/Personal ID",
                isActive: true,
            },
        ],
    },
    {
        id: 31,
        geonamesId: 3469034,
        code: "BR",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Brasil",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "RG",
                name: "Registro Geral",
                isActive: true,
            },
            {
                id: 1,
                code: "CI",
                name: "Carteira de Identidade",
                isActive: true,
            },
        ],
    },
    {
        id: 49,
        geonamesId: 3686110,
        code: "CO",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Colombia",
        isActive: true,
        identification: [
            // {
            //     id: 1,
            //     code: 'PASSPORT',
            //     name: 'Passport',
            //     isActive: true,
            // },
            {
                id: 1,
                code: "CEDCI",
                name: "Cédula de ciudadanía",
                isActive: true,
            },
        ],
    },
    {
        id: 210,
        geonamesId: 3585968,
        code: "SV",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "El Salvador",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "DUI",
                name: "Documento único de identidad",
                isActive: true,
            },
        ],
    },
    {
        id: 91,
        geonamesId: 3595528,
        code: "GT",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Guatemala",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "DUI",
                name: "Documento personal de identificación",
                isActive: true,
            },
        ],
    },
    {
        id: 97,
        geonamesId: 3608932,
        code: "HN",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Honduras",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "TID",
                name: "Tarjeta de identidad",
                isActive: true,
            },
        ],
    },
    {
        id: 173,
        geonamesId: 3703430,
        code: "PA",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Panamá",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CIP",
                name: "Cédula de identidad personal",
                isActive: true,
            },
        ],
    },
    {
        id: 186,
        geonamesId: 3437598,
        code: "PY",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Paraguay",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CIC",
                name: "Cédula de identidad Civil",
                isActive: true,
            },
        ],
    },
    {
        id: 184,
        geonamesId: 2264397,
        code: "PT",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Portugal",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CDC",
                name: "Cartão de Cidadão",
                isActive: true,
            },
        ],
    },
    {
        id: 182,
        geonamesId: 4566966,
        code: "PR",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "Puerto Rico",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "DL",
                name: "Licencia de Conducir",
                isActive: true,
            },
            {
                id: 1,
                code: "ID",
                name: "Identificación",
                isActive: true,
            },
        ],
    },
    {
        id: 61,
        geonamesId: 3508796,
        code: "DO",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
            systemCreatedAt: "2020-04-29T20:48:29.000-0500",
        },
        name: "República Dominicana",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
            {
                id: 1,
                code: "CIE",
                name: "Cédula de identidad y electoral",
                isActive: true,
            },
        ],
    },
    {
        id: 0,
        code: "OTHER",
        language: {
            id: 1,
            code: "es",
            name: "Spanish",
            isActive: true,
        },
        name: "Other country",
        isActive: true,
        identification: [
            {
                id: 1,
                code: "PASSPORT",
                name: "Passport",
                isActive: true,
            },
        ],
    },
];
export default countryIdentificationCatalog;